var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrimaryLook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.84 27.363v16.625a2.104 2.104 0 01-2.107 2.103h-3.568a.21.21 0 01-.21-.21V29.255c0-1.161.942-2.103 2.105-2.103h3.569a.21.21 0 01.21.21z",
    fill: "url(#primary_look_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.922 2.206v19.459a.21.21 0 01-.21.21h-3.59a2.105 2.105 0 01-2.107-2.102V.313a.21.21 0 01.21-.21h3.59c1.165 0 2.107.942 2.107 2.103z",
    fill: "url(#primary_look_svg__paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.922 37.133V52.09c0 1.16-.942 2.102-2.107 2.102h-3.59a.21.21 0 01-.21-.21V39.025c0-1.161.942-2.102 2.106-2.102h3.59a.21.21 0 01.211.21z",
    fill: "url(#primary_look_svg__paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89 42.277v9.813c0 1.16-.942 2.102-2.105 2.102H.21a.21.21 0 01-.211-.21v-9.813c0-1.161.943-2.102 2.107-2.102h3.572a.21.21 0 01.211.21z",
    fill: "url(#primary_look_svg__paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.84 10.315v8.523a.21.21 0 01-.211.211H22.06a2.104 2.104 0 01-2.106-2.102V8.423a.21.21 0 01.21-.21h3.57c1.162 0 2.105.94 2.105 2.102z",
    fill: "url(#primary_look_svg__paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89 2.207v9.814a.21.21 0 01-.21.21H2.106A2.104 2.104 0 010 10.13V.315a.21.21 0 01.21-.21h3.575c1.163 0 2.105.94 2.105 2.102z",
    fill: "url(#primary_look_svg__paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.197 53.99V40.016a5.043 5.043 0 00-1.48-3.568l-5.165-5.153a5.06 5.06 0 00-3.573-1.477h-14a.21.21 0 00-.211.21v13.973c0 1.339.532 2.622 1.48 3.569l5.164 5.152a5.059 5.059 0 003.573 1.478h14.001a.21.21 0 00.21-.21z",
    fill: "url(#primary_look_svg__paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.197.21v13.974a5.043 5.043 0 01-1.48 3.568l-5.165 5.153a5.06 5.06 0 01-3.573 1.477h-14a.21.21 0 01-.211-.21V10.2c0-1.339.532-2.622 1.48-3.569l5.164-5.152A5.058 5.058 0 0139.985 0h14.001a.21.21 0 01.21.21z",
    fill: "url(#primary_look_svg__paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M223.301 33.055h-17.089v6.7h17.089v-6.7z",
    fill: "url(#primary_look_svg__paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.947 1.289v6.7h-14.283c-.931 0-1.859.038-2.78.188-2.624.579-4.517 3.121-4.716 5.763-.075 1.385-.063 2.775-.057 4.157h-.01v3.268h18.086v6.7H238.11c.013 8.537.004 17.067.004 25.6h-6.868c.01-8.331 0-16.664.01-25.003v-8.365c.091-3.02-.26-6.09.274-9.082.763-4.034 3.682-7.567 7.502-9.004 1.773-.729 3.64-.9 5.527-.92.152-.003.3-.003.456-.003h14.932z",
    fill: "url(#primary_look_svg__paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.119 1.917c-.01 2.022-.01 4.047.003 6.072h-3.719c-.934 0-1.868.038-2.792.188-2.624.579-4.516 3.12-4.716 5.763-.072 1.385-.06 2.775-.054 4.157h-.009v3.268h11.287v6.7H160.84c.013 8.536.004 17.067.004 25.6h-6.868c.01-8.331 0-16.665.01-25.003v-8.365c.091-3.021-.263-6.09.271-9.082.763-4.034 3.685-7.567 7.502-9.004 1.918-.785 3.947-.923 5.989-.923h4.371v.026h.003l-.003.603z",
    fill: "url(#primary_look_svg__paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M198.227 53.034v.63h-4.372c-2.041 0-4.07-.138-5.989-.924-3.816-1.437-6.738-4.97-7.501-9.002-.535-2.992-.181-6.062-.271-9.083V26.29c-.011-8.339 0-16.671-.011-25.004h6.869c0 6.065.003 12.13.003 18.194v1.885h11.271v6.7h-11.271v5.522h-.016v3.267h.01c-.006 1.383-.019 2.773.054 4.159.199 2.64 2.092 5.183 4.716 5.762.924.15 1.858.188 2.791.188h3.719a558.54 558.54 0 00-.002 6.071z",
    fill: "url(#primary_look_svg__paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M308 53.668h-8.976l-.526-.994-1.956-3.733a281.787 281.787 0 00-2.086-3.97c-1.971-3.683-3.966-7.343-5.473-11.201a44.738 44.738 0 01-.968-2.728l-.329-1.057-.329 1.057c-.295.923-.617 1.83-.969 2.728-1.506 3.858-3.501 7.518-5.473 11.2a281.719 281.719 0 00-2.085 3.971l-1.957 3.733-.525.994h-8.976l8.485-14.874c.748-1.307 1.495-2.613 2.245-3.92v-.002c.216-.38.434-.764.649-1.153l.101-.179 1.766-3.088.26-.457a6.418 6.418 0 00.712-2.95 6.463 6.463 0 00-.766-3.057l-2.415-4.248-5.223-9.185-1.848-3.236-2.871-5.042-.566-.99h8.856l.537.99 2.824 5.148 1.007 1.83c1.329 2.469 2.636 4.966 4.013 7.435a41.417 41.417 0 011.539 3.14c.237.527.462 1.06.683 1.596l.326.802.326-.802c.221-.536.446-1.07.683-1.597a41.407 41.407 0 011.538-3.139c1.377-2.469 2.684-4.966 4.014-7.435l1.007-1.83 2.823-5.148.538-.99h8.856l-.566.99-2.87 5.042-1.849 3.236-5.223 9.185-2.416 4.248a6.463 6.463 0 00-.765 3.056c0 1.064.256 2.066.712 2.951l.259.457 1.766 3.088.102.179c.215.39.433.773.648 1.153v.003c.751 1.306 1.498 2.612 2.245 3.919L308 53.668z",
    fill: "url(#primary_look_svg__paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.549 9.43c5.195-.891 10.853-.597 15.543 2.03 3.755 2.088 6.242 5.973 7.302 10.094 1.098 4.037 1.021 8.255.952 12.399-.145 5.063-1.382 10.408-4.86 14.235-3.463 3.83-8.729 5.5-13.762 5.469-5.014.136-10.431-1.046-14.073-4.752-3.609-3.595-4.941-8.84-5.218-13.81-.192-5.922-.303-12.229 2.622-17.58 2.269-4.366 6.734-7.264 11.494-8.085zm1.95 5.43c-2.514.43-4.886 1.81-6.318 3.972-2.096 3.175-2.564 7.111-2.6 10.842-.023 3.64-.104 7.378 1.064 10.877.809 2.579 2.456 5.008 4.925 6.208 3.068 1.453 6.676 1.565 9.912.65 2.722-.774 4.948-2.888 6.05-5.496 1.811-4.206 1.563-8.91 1.52-13.394-.15-3.924-.836-8.247-3.754-11.106-2.814-2.773-7.098-3.16-10.799-2.552z",
    fill: "url(#primary_look_svg__paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.692 45.194c-1.046 3.093-3.595 5.472-6.52 6.748-3.931 1.766-8.382 2.023-12.606 1.45-3.794-.548-7.633-2.176-10.089-5.26-1.162-1.427-1.902-3.136-2.362-4.914l-.182-.76-.274-1.16h6.726c.808 3.23 3.813 5.36 6.94 5.942 3.423.638 7.293.428 10.218-1.675 1.763-1.22 2.763-3.581 2.033-5.668-.735-2.146-2.828-3.376-4.813-4.14-3.996-1.502-8.084-2.76-12.067-4.304-3.106-1.253-6.096-3.515-7.092-6.88-1.065-3.713-.414-8.059 2.204-10.973 2.4-2.693 5.968-3.99 9.452-4.443 4.558-.507 9.493-.062 13.395 2.571 2.33 1.55 3.991 3.98 4.735 6.678l.187.761.293 1.183h-6.735c-.782-2.445-2.95-4.155-5.364-4.779-3.227-.85-6.942-.774-9.814 1.108-1.725 1.113-2.683 3.37-2.009 5.369.563 1.783 2.26 2.844 3.893 3.496 3.55 1.315 7.125 2.54 10.679 3.845 2.888 1.065 5.749 2.59 7.68 5.073 2.339 2.984 2.677 7.203 1.492 10.732z",
    fill: "url(#primary_look_svg__paint14_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint0_linear",
    x1: 19.363,
    y1: 27.214,
    x2: 28.443,
    y2: 45.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint1_linear",
    x1: 9.422,
    y1: 0.175,
    x2: 20.664,
    y2: 19.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint2_linear",
    x1: 9.422,
    y1: 36.979,
    x2: 17.22,
    y2: 53.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint3_linear",
    x1: -0.591,
    y1: 42.106,
    x2: 3.635,
    y2: 55.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint4_linear",
    x1: 19.363,
    y1: 8.248,
    x2: 22.806,
    y2: 20.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint5_linear",
    x1: -0.591,
    y1: 0.144,
    x2: 3.635,
    y2: 13.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint6_linear",
    x1: 27.315,
    y1: 29.897,
    x2: 31.756,
    y2: 58.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint7_linear",
    x1: 54.197,
    y1: 0,
    x2: 29.814,
    y2: 24.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint8_linear",
    x1: 204.497,
    y1: 33.077,
    x2: 204.986,
    y2: 41.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint9_linear",
    x1: 228.342,
    y1: 1.458,
    x2: 244.848,
    y2: 59.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint10_linear",
    x1: 152.13,
    y1: 1.459,
    x2: 175.566,
    y2: 53.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint11_linear",
    x1: 178.238,
    y1: 1.456,
    x2: 201.674,
    y2: 53.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint12_linear",
    x1: 263.294,
    y1: 1.457,
    x2: 275.423,
    y2: 61.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint13_linear",
    x1: 103.532,
    y1: 9.121,
    x2: 113.027,
    y2: 60.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary_look_svg__paint14_linear",
    x1: 64.377,
    y1: 9.118,
    x2: 75.295,
    y2: 60.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}

export default SvgPrimaryLook;